import axios from 'axios';

import { AUTH_CSRF_PATH } from '@treneo/shared/constants';
import { logger } from '@treneo/shared/logger';

import { getApiBaseUrl } from './config';

export const fetchCsrfToken = async (signal?: AbortSignal): Promise<string> => {
  try {
    const baseUrl = getApiBaseUrl();
    const response = await axios.get(`${baseUrl}${AUTH_CSRF_PATH}`, {
      signal,
      timeout: 5000,
      withCredentials: true
    });
    return response.data?.isSuccess ? response.data.data : '';
  } catch (error) {
    if (error instanceof Error && error.name === 'AbortError') {
      throw error;
    }
    logger.warn('Failed to fetch CSRF token:', error);
    return '';
  }
};
